import React from 'react';
import classNames from 'classnames';
import CloseOutlined from '@haier/icons/CloseOutlined';
import Button from '../button';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
function isValidNode(node) {
    return node !== undefined && node !== null;
}
const PanelRender = ({ stepsProps, current, type, indicatorsRender, showClose, }) => {
    var _a, _b, _c;
    const { prefixCls, title, description, total = 1, className, cover, onClose, onFinish, onPrev, onNext, nextButtonProps, prevButtonProps, passButtonProps, type: stepType, } = stepsProps;
    const tourLocale = useLocaleReceiver('Tour')[0]; // Force TS get this
    const panelClassName = classNames(className, `${prefixCls}-content`);
    const isLastStep = current === total - 1;
    const coverNode = isValidNode(cover) ? React.createElement("div", { className: `${prefixCls}-cover` }, cover) : null;
    const headerNode = isValidNode(title) ? (React.createElement("div", { className: `${prefixCls}-header` },
        React.createElement("div", { className: `${prefixCls}-title` }, title))) : null;
    const descriptionNode = isValidNode(description) ? (React.createElement("div", { className: `${prefixCls}-description` }, description)) : null;
    let mergeIndicators;
    if (indicatorsRender) {
        mergeIndicators = indicatorsRender(current, total);
    }
    else {
        mergeIndicators = [...Array.from({ length: total }).keys()].map((stepItem, index) => (React.createElement("span", { key: stepItem, className: classNames(index === current && `${prefixCls}-indicator-active`, `${prefixCls}-indicator`) })));
    }
    const prevBtnClick = () => {
        var _a;
        onPrev === null || onPrev === void 0 ? void 0 : onPrev();
        (_a = prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(prevButtonProps);
    };
    const nextBtnClick = () => {
        var _a;
        if (isLastStep) {
            onFinish === null || onFinish === void 0 ? void 0 : onFinish();
        }
        else {
            onNext === null || onNext === void 0 ? void 0 : onNext();
        }
        (_a = nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(nextButtonProps);
    };
    const passBtnClick = () => {
        var _a;
        onFinish === null || onFinish === void 0 ? void 0 : onFinish();
        (_a = passButtonProps === null || passButtonProps === void 0 ? void 0 : passButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(passButtonProps);
    };
    const mergedType = stepType !== null && stepType !== void 0 ? stepType : type;
    const secondaryBtnProps = {
        type: 'default',
        ghost: mergedType === 'primary',
    };
    const footerNode = (React.createElement("div", { className: `${prefixCls}-footer` },
        total > 1 && React.createElement("div", { className: `${prefixCls}-indicators` }, mergeIndicators),
        React.createElement("div", { className: `${prefixCls}-buttons` },
            !isLastStep ? (React.createElement(Button, Object.assign({}, passButtonProps, { size: "small", type: "text", className: classNames(`${prefixCls}-pass-btn`, passButtonProps === null || passButtonProps === void 0 ? void 0 : passButtonProps.className), onClick: passBtnClick }), (_a = passButtonProps === null || passButtonProps === void 0 ? void 0 : passButtonProps.children) !== null && _a !== void 0 ? _a : '跳过')) : (''),
            current !== 0 ? (React.createElement(Button, Object.assign({}, secondaryBtnProps, prevButtonProps, { size: "small", className: classNames(`${prefixCls}-prev-btn`, prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.className), onClick: prevBtnClick }), (_b = prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.children) !== null && _b !== void 0 ? _b : tourLocale === null || tourLocale === void 0 ? void 0 : tourLocale.Previous)) : null,
            React.createElement(Button, Object.assign({ type: "primary" }, nextButtonProps, { size: "small", className: classNames(`${prefixCls}-next-btn`, nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.className), onClick: nextBtnClick }), (_c = nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.children) !== null && _c !== void 0 ? _c : (isLastStep ? tourLocale === null || tourLocale === void 0 ? void 0 : tourLocale.Finish : tourLocale === null || tourLocale === void 0 ? void 0 : tourLocale.Next)))));
    return (React.createElement("div", { className: panelClassName },
        React.createElement("div", { className: `${prefixCls}-inner` },
            showClose && React.createElement(CloseOutlined, { className: `${prefixCls}-close`, onClick: onClose }),
            coverNode,
            headerNode,
            descriptionNode,
            footerNode)));
};
export default PanelRender;
